
( function() {
	'use strict';

	const logoCarousel = document.querySelectorAll( '.logo-carousel--animate-true' );

	/**
	 * Helper Function for debouncing
	 */
	function debounce( func, wait, immediate ) {
		var timeout;
		return function () {
			var context = this, args = arguments;

			/**
			 * Set timeout for debounce
			 */
			var later = function () {
				timeout = null;
				if ( !immediate ) func.apply( context, args );
			};

			var callNow = immediate && !timeout;

			clearTimeout( timeout );
			timeout = setTimeout( later, wait );
			if ( callNow ) func.apply( context, args );

		};
	}

	let windowWidth = window.innerWidth;

	const checkWidth = debounce( function () {

		//make sure windowWidth does not match currentWidth (fixes ios bug)
		if ( window.innerWidth != windowWidth ) {

			logoCarousel.forEach( ( i ) => {

				const logoCarouselRow = i.querySelectorAll( '.logo-carousel__row' );

				//make sure the row exists
				if ( '' !== logoCarouselRow ) {

					logoCarouselRow.forEach( ( parent ) => {

						const children = Array.from( parent.children );
						//set a width var
						let totalWidth = 0;
						//reset the width
						children.forEach( ( childItem ) => {
							totalWidth += childItem.getBoundingClientRect().width;
						} );
						const roundedWidth = Math.round( totalWidth );
						//set row width
						parent.style.width = roundedWidth  + 'px';

					} );
				}
			} );
			//reset our windowWidth var
			windowWidth = window.innerWidth;
		}

	}, 250 );

	logoCarousel.forEach( ( i ) => {

		const logoCarouselRow = i.querySelectorAll( '.logo-carousel__row' );

		//check classList for true animation
		if ( i.classList.contains( 'logo-carousel--animate-true' ) ) {

			//duplicate any rows
			logoCarouselRow.forEach( ( parent ) => {
				const children = Array.from( parent.children );
				//set childCount and duplicate by 2 since we're about to duplicate nodes
				const childCount = parent.children.length * 2;
				//width var
				let totalWidth = 0;
				//duplicate nodes
				children.forEach( ( childItem ) => {
					totalWidth += childItem.getBoundingClientRect().width;
					const clonedItem = childItem.cloneNode( true );
					parent.appendChild( clonedItem );
				} );
				//round our
				const roundedWidth = Math.round( totalWidth * 2 );
				//set the total brands css var
				parent.style.setProperty( '--total-brands', childCount );
				//set row width * 2 to account for cloned nodes
				parent.style.width = roundedWidth + 'px';
			} );
			
		}
	} );

	//resize listener
	window.addEventListener( 'resize', checkWidth ); /* On Resize */

} () );

